import React, { useRef } from "react"
import AddNewAuthorization from "./AddNewAuthorization"
import { ServerRequestProtected, ServerRequestPublic } from "../../../../../utils/ServerDataRequest"
import { useState, useReducer } from "react"
import { enumUtil } from "../../../../../utils/Enum"
import NotificationHandler from "../../../../../utils/NotificationHandler"
import { useEffect } from "react"
import Loader from "../../../../shared/Loader/Loader"
import Table from "../../../../Setup/Shared/Table"
import GridColumnHeader from "../../../../Setup/Shared/GridColumnHeader"
import Nav from 'react-bootstrap/Nav';
import { NavItem, NavLink } from 'reactstrap';
import Modal from 'react-bootstrap/Modal';
import { connect, useSelector } from "react-redux"
import { saveAs } from "file-saver"
import isNull from "../../../../../utils/NullChecking"
import handleCopyText from "../../../../shared/CopyData"
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import AddMasterWeek from "../../PatientCalendar/MasterWeekPopup/AddMasterWeek"
import AddNewAuthForPractice from "./AddNewAuthForPractice"
import { GeneralDropDowns } from "../../../../../actions/GeneralPatientActions"
import { useDispatch } from "react-redux"
const Authorization = (props) => {
    let Authorization_Modal = {
        AuthorizationType: "",
        PatientID: "",
        PatientInsuranceID: "",
        ProviderID: "",
        LocationID: "",
        DiagnosisCode1: "",
        DiagnosisCode2: "",
        ProcedureCode: "",
        AuthorizationNumber: "",
        StartDate: null,
        EndDate: null,
        AuthorizationStatus: "",
        VisitsAllowed: "",
        Remarks: "",
        AuthorizeUnits: "",
        UtilizedUnits: "",
        RemainingUnits: "",
        Status: '',
        Frequency: '',
        AuthorizationDocument: '',
        FileName: '',
    }
    let isADC = useSelector(state => state.GeneralDropDownsReducer.PracticeType === "Adult Day Care")
    const { Settings } = { ...props }
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const API_URL = enumUtil.controller.PATIENT
    const API_URL_GENERAL = enumUtil.controller.General
    const [AuthorizationID, setAuthorizationID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [IsOpenAuthorization, setIsOpenAuthorization] = useState(false);
    const [AuthorizationData, setAuthorizationData] = useState([]);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [AuthorizationDetails, setAuthorizationDetails] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [modalActive, setModalActive] = useState(false)
    const [mainAuthorizationModal, setmainAuthorizationModal] = useState(Authorization_Modal);
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const [submissionHistoryData, setSubmissionHistoryData] = useState([]);
    const [isOpenViewpdf, setisOpenViewpdf] = useState(false)
    const [npiModal, setNpiModal] = useState(false)
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    const isFirstRender = useRef(true);
    const isFirstRender2 = useRef(true);

    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false   // set true if want to display cards as well
    }
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    //For Pagination
    const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();

    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    ///////////

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////

    //insurance List
    let InsuranceList_Modal = [{
        PatientInsuranceID: "",
        CoveragePriority: "",
        InsuranceName: "",
    }]
    const [activeTab, setActiveTab] = useState()
    const [PatientInsuranceID, setPatientInsuranceID] = useState('0');
    const [InsuranceListModal, setInsuranceListModal] = useState([InsuranceList_Modal]);
    const [isMasterWeekOpen, setIsMasterWeekOpen] = useState(false);
    const [masterWeekID, setMasterWeekID] = useState(0)
    const handleActivePlan = (ID) => {
        if (activeTab !== ID) {
            setActiveTab(ID)
        }
        setPatientInsuranceID(ID)
    }
    const AddNewPlan = () => {
        setPatientInsuranceID('0')
        setActiveTab('0')
        // setmainInsurancePlanModal(InsurancePlan_Modal)
    }
    useEffect(() => {
        if (props.Reload !== undefined && props.Reload === false && props.Reload !== '') {
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
            }
            let data = props.id
            data.map((item) => {
                if (item.key === 2132) {
                    handleInsurranceDetails()
                }
            })
            if (data.length === 0) {
                handleInsurranceDetails()
            }
        }
    }, [props.Reload])
    const handleInsurranceDetails = async () => {
        setAuthorizationDetails(false)
        if (PateintIDR != -1) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPatientInsuranceDetails", 'post', {
                "ID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.PatientInsurance
            }).then(async (response) => {
                setInsuranceListModal(response)
                setActiveTab(response[0].PatientInsuranceID)
                handleActivePlan(response[0].PatientInsuranceID)
                ServerRequestProtected(API_URL + "/FindPatientAuthorization", 'post', {
                    "TableName": enumUtil.enumAPITableName.PatientAuthorization,
                    "ID": response[0].PatientInsuranceID + "",
                    "PerPage": PerPage + "",
                    "PageNo": PageNo + "",
                }).then((response) => {
                    setIsLoading(false)
                    handleGridHeader({ defaultData: response.Rows })
                    setAuthorizationData(response.Rows)
                    setTotalPages(response.count.NumOfPages);
                }).catch((error) => {
                    setIsLoading(false)
                })
            })
                .catch((error) => {
                    setIsLoading(false)
                })
        }
    }
    // useEffect(() => {
    //     LoadData();
    //     // handleInsurranceDetails()
    // }, [PerPage, PageNo])
    useEffect(() => {
        handleInsurranceDetails()
    }, [])
    useEffect(() => {
        if (PatientInsuranceID != '0') {
            if (isFirstRender2.current) {
                // Skip on first render
                isFirstRender2.current = false;
                return;
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPatientAuthorization", 'post', {
                "TableName": enumUtil.enumAPITableName.PatientAuthorization,
                "ID": PatientInsuranceID + "",
                "PerPage": PerPage + "",
                "PageNo": PageNo + "",
            }).then((response) => {
                setIsLoading(false)
                handleGridHeader({ defaultData: response.Rows })
                setAuthorizationData(response.Rows)
                setTotalPages(response.count.NumOfPages);
            }).catch((error) => {
                setIsLoading(false)
                setAuthorizationData([])
            })
        }
    }, [PatientInsuranceID, isClose, PerPage, PageNo])
    ////

    const LoadData = (param) => {
        setIsLoading(true)
        setAuthorizationData([])
        ServerRequestProtected(API_URL + "/FindPatientAuthorization", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientAuthorization,
            "ID": PatientInsuranceID + "",
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": PageNo,
        }).then((response) => {
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setAuthorizationData(response.Rows)
            setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setIsLoading(false)
        })
    }
    const AddInsurance = (ID) => {
        setIsOpenAuthorization(true)
        setNpiModal(true)
        setAuthorizationID(ID)
    }
    const CloseInsurance = () => {
        setIsOpenAuthorization(false)
        setIsClose((Math.random()));
        setNpiModal(false)
    }
    const DeleteInsurance = () => {
        setIsOpenAuthorization(false)
        setIsClose((Math.random()));
    }
    const onCloseProocedNpi = () => {
        setNpiModal(false)
    }
    const proceedHeader = () => {
        return <p className="heading">Add Authorization using pdf</p>;
    };
    let PopupScreen = "";
    if (IsOpenAuthorization) {
        if (isHomeCareCheck === 'true') {
            PopupScreen = <AddNewAuthorization IsOpenAuthorization={IsOpenAuthorization} onCloseProocedNpi={onCloseProocedNpi} npiModal={npiModal} proceedHeader={proceedHeader} onClose={CloseInsurance} onDeleteInsurance={DeleteInsurance} AuthorizationID={AuthorizationID} PatientInsuranceID={PatientInsuranceID} InsuranceListModal={InsuranceListModal} />
        } else {
            PopupScreen = <AddNewAuthForPractice IsOpenAuthorization={IsOpenAuthorization} onCloseProocedNpi={onCloseProocedNpi} npiModal={npiModal} proceedHeader={proceedHeader} onClose={CloseInsurance} onDeleteInsurance={DeleteInsurance} AuthorizationID={AuthorizationID} PatientInsuranceID={PatientInsuranceID} InsuranceListModal={InsuranceListModal} />
        }

    }

    const handleOpenMasterWeek = (data) => {
        setIsMasterWeekOpen(true);
        setMasterWeekID(0);
    }

    const onCloseMasterWeek = () => {
        setIsMasterWeekOpen(false);
    }

    const onCloseMasterWeekSave = () => {
        setIsMasterWeekOpen(false);
    }

    let MasterWeekPopup = "";
    if (isMasterWeekOpen) {
        MasterWeekPopup = <AddMasterWeek isMasterWeekOpen={isMasterWeekOpen} onClose={onCloseMasterWeek} onCloseSave={onCloseMasterWeekSave} ID={masterWeekID} InvalidApi={() => { }} />
    }
    const ViewPdf = (BucketPath) => {
        setImgFile(null)
        setIsLoading(true);
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": BucketPath
        }, 'Download').then((response) => {
            setIsLoading(false)
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setTxtFile(content);
                };
                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/jepg') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setImgFile(objectURL)
            } else if (response.type === 'application/tiff') {

            }
            else if (response.type === 'application/pdf') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);

                setPdfFile(objectURL)
            }
            setModalActive(true)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }
    const DownloadFile = (BucketPath, FileName) => {

        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": BucketPath,
        }, "Download",)
            .then((response) => {
                setIsLoading(false)
                let blob = new Blob([response], { type: 'image/jpeg' });
                saveAs(blob, FileName);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
            })
    }
    const [copiedText, setCopiedText] = useState({});


    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;

        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [

        {
            key: 'AuthorizationNumber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Authorization #'} sortIcon={true} type={'number'} colKey={'AuthorizationNumber'} data={AuthorizationData} setData={setAuthorizationData} />),
            renderCell: ({ row }) => {
                return (
                    <button
                        className="btn btn-link p-0" onClick={() => AddInsurance(row.PatientAuthorizationID)}>
                        {row.AuthorizationNumber}
                    </button>
                );
            },
        },
        {
            key: 'StartDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Start Date'} sortIcon={true} type={'string'} colKey={'StartDate'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        {
            key: 'EndDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'End Date'} sortIcon={true} type={'string'} colKey={'EndDate'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        {
            key: 'Frequency',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Frequency'} sortIcon={true} type={'string'} colKey={'Frequency'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        ...(isADC ? [
            {
                key: 'IsTranspotation',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Authorization'} sortIcon={true} type={'string'} colKey={'IsTranspotation'} data={AuthorizationData} setData={setAuthorizationData} />),
                resizable: true,
                width: 150,
            },
        ] : []),
        {
            key: 'ProcedureCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'CPTs'} sortIcon={true} type={'string'} colKey={'ProcedureCode'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        {
            key: 'DiagnosisCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'ICDs'} sortIcon={true} type={'string'} colKey={'DiagnosisCode'} data={AuthorizationData} setData={setAuthorizationData} />),
            // width: 120
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.DiagnosisCode}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.PatientAuthorizationID, row.DiagnosisCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.PatientAuthorizationID}-${row.DiagnosisCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'AuthorizeUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Authorize Units'} sortIcon={true} type={'number'} colKey={'AuthorizeUnits'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        ...(isHomeCareCheck === 'true'
            ? [
                {
                    key: 'ScheduleUnits',
                    name: (
                        <GridColumnHeader
                            gridHeader={gridHeader}
                            handleGridHeader={handleGridHeader}
                            iconName={'icon-card'}
                            headerName={'Schedule Units'}
                            sortIcon={true}
                            type={'number'}
                            colKey={'ScheduleUnits'}
                            data={AuthorizationData}
                            setData={setAuthorizationData}
                        />
                    ),
                },
            ]
            : []),
        {
            key: 'UtilizedUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Utilized Units'} sortIcon={true} type={'number'} colKey={'UtilizedUnits'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        {
            key: 'RemainingUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Remaining Units'} sortIcon={true} type={'number'} colKey={'RemainingUnits'} data={AuthorizationData} setData={setAuthorizationData} />),
        },
        {
            key: 'AuthorizationStatus',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'AuthorizationStatus'} data={AuthorizationData} setData={setAuthorizationData} />),
            width: 150,
            renderCell: ({ row }) => {
                switch (row.AuthorizationStatus) {
                    case 'Active':
                        return <span className='ar-user_active pill'>{row.AuthorizationStatus}</span>;
                    case 'Expired':
                        return <span className='pill Partialdenied'>{row.AuthorizationStatus}</span>;
                    case 'Expiring':
                        return <span className='pill Missing-Info'>{row.AuthorizationStatus}</span>;
                    default:
                        return <>{row.AuthorizationStatus}</>;
                }
            }
        },
        {
            key: 'AuthorizationDocument',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Action'} sortIcon={true} type={'string'} colKey={'AuthorizationDocument'} data={AuthorizationData} setData={setAuthorizationData} />),
            renderCell: ({ row }) => {
                return (
                    <>
                        {!isNull(row.AuthorizationDocument) ?
                            <div className="btnWrapper-col">
                                <button className='border-0 no-width  Sdownload-btn' onClick={() => DownloadFile(row.AuthorizationDocument, row.FileName)} >
                                    <i className="icon-download-svgrepo-com" />
                                    <p class="tool_tip xsm_text text-light" >Download</p>
                                </button>
                                <button className='border-0 bg-transparent no-width rounded eye' onClick={() => ViewPdf(row.AuthorizationDocument)} >
                                    <i class="icon-Icon-awesome-eye"></i>
                                    <p class="tool_tip xsm_text text-light">View</p>
                                </button>
                            </div>
                            : <p>File Not Found!</p>}
                    </>
                );
            },
        },
    ]
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }

    const onCloseFileViewer = () => {
        setModalActive(false)
        setPdfFile(null)
        setTxtFile(null)
        setImgFile(null)
    }
    const getIconClass = (Status, isSelected) => {
        // console.log(Status, isSelected);
        // let  isSelected = activeTab === item.PatientInsuranceID
        if (Status && isSelected) {
            return "";
        } else if (Status && !isSelected) {
            return "opacity-40";
        } else if (Status === false && isSelected) {
            return "red";
        } else if (Status === false && isSelected === false) {
            return "red opacity-40";
        } else {
            return "blue opacity-40";
        }
    };
    let dispatch = useDispatch();

    useEffect(() => {
        if (PateintIDR !== -1) {
            if (DropDowns.DiscardIndicator === true) {
                dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
            }
        }
    }, [DropDowns.DiscardIndicator])

    return (
        <>
            <Modal show={modalActive} onHide={() => onCloseFileViewer()} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
                <Modal.Body>
                    <div className="download-header">
                        <div className='hide-me'></div>
                        <button className="btn-icon-transparent" onClick={() => onCloseFileViewer()}>
                            <i className="icon-Icon-metro-cross"></i>
                        </button>
                    </div>
                    <div className="pdfView-box">
                        {!isNull(txtFile) ? txtFile : ''}
                        {!isNull(imgFile) ? <img src={imgFile} alt='application/jpg' /> : ''}

                    </div>
                    {isLoading ? <Loader /> : null}
                    {pdfFile &&
                        <>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                <Viewer fileUrl={pdfFile}
                                    defaultScale={1}
                                    plugins={[defaultLayoutPluginInstance]} />
                            </Worker>
                        </>
                    }
                    {/* Other content */}
                </Modal.Body>
                <div className='btns-group text-end px-10 py-2 br-top-1 br-clr'>
                    <button className='btn btn-gray' onClick={() => onCloseFileViewer()}>Cancel</button>
                </div>
            </Modal>

            <div className="col-md-12 pe-3 me-1 mb-2">
                <div className='d-flex justify-content-end gap-2'>
                    {isHomeCareCheck === 'true' && <button className='btn btn-orange rounded text font-m fs-12 text-white px-2' onClick={() => handleOpenMasterWeek(0)}>Create Master Week</button>}
                    <button className='btn-icon-circle btn-xs' onClick={() => AddInsurance()}><i className="icon-Group-5719"></i></button>

                </div>
            </div>

            <div className="tabs-container">
                <div className="">
                    {PopupScreen}
                    {MasterWeekPopup}
                    <div className="row m-0 create_plan app-vertical-tabs ">
                        <div className="col-md-2 tabs-menu p-0 ">
                            <div className='py-3 text-center'>
                                {/* <button className='btn btn-theme btn-xs no-width'> Create Plan</button> */}
                            </div>
                            <Nav variant="tabs">
                                {InsuranceListModal && InsuranceListModal.map((item) => {
                                    return (
                                        <React.Fragment key={item.PatientInsuranceID}>
                                            <NavItem onClick={() => handleActivePlan(item.PatientInsuranceID)}  >
                                                <NavLink href='#' className={activeTab === item.PatientInsuranceID ? "active" : ""}>
                                                    <div className='tab-img' >
                                                        <span className={`icon-insurance-patient fs-60 ${getIconClass(item.STATUS, activeTab === item.PatientInsuranceID)}`}><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                                        <div className={item.CoveragePriority === "P" ? "hk-status p" : item.CoveragePriority === "S" ? "hk-status s" : item.CoveragePriority === "T" ? "hk-status T" : item.CoveragePriority === "O" ? "hk-status O" : ''}>
                                                            {item.CoveragePriority === "P" ? "P" : item.CoveragePriority === "S" ? "S" : item.CoveragePriority === "T" ? "T" : item.CoveragePriority === "O" ? "O" : ''}
                                                        </div>
                                                    </div>
                                                    {item.ShortName}
                                                </NavLink>
                                            </NavItem>
                                        </React.Fragment>
                                    )
                                })}
                            </Nav>
                        </div>
                        <div className="col-md-10 position-relative p-0">
                            {isLoading ? <Loader /> : null}
                            {show === false ?
                                <Table
                                    columns={columns}
                                    rows={AuthorizationData}
                                    height='375px'
                                    rowClass={rowClass}
                                    // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                    dynamicClass='fill-grid DataGrid-Table hk-exp-table authorization_table'
                                    rowHeight={25}
                                    PerPage={PerPage}
                                    PageNo={PageNo}
                                    TotalPages={TotalPages}
                                    handlePageClick={handlePageClick}
                                    PreviousPage={PreviousPage}
                                    handleFingByCreteria={handleFingByCreteria}
                                    NextPage={NextPage}
                                    Key={2132}
                                    Name={'Eligibility'}
                                    hideColClass={'hide'}
                                    isLoading={isLoading}
                                /> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(Authorization)